// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GR41","col":"styles_col__1KbTQ"};